import CustomForm from "../CustomForm";

export default abstract class UX extends CustomForm {

    public rewriteFormControls() {
        return true;
    }

}